import { cn } from "@omni/utils/styles";
import { Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { useImageGalleryContext } from "@/components/ImageGallery/context/imageGallery.context";
import { BreakpointMinSizes } from "@/services/breakpoint.service";
import {
    getEffectiveLayoutSettings,
    LayoutSettings
} from "@/utils/swiper.utils";

type Props = {
    className?: string;
};

const layoutSettings: LayoutSettings = {
    [BreakpointMinSizes.xs]: {
        slidesPerView: 3.6,
        slidesPerGroup: 3,
        direction: "horizontal"
    },
    [BreakpointMinSizes.sm]: {
        slidesPerView: 3.6,
        slidesPerGroup: 3,
        direction: "horizontal"
    },
    [BreakpointMinSizes.md]: {
        slidesPerView: 3.6,
        slidesPerGroup: 3,
        direction: "horizontal"
    },
    [BreakpointMinSizes.lg]: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        direction: "horizontal"
    },
    [BreakpointMinSizes.xl]: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        direction: "horizontal"
    }
};

export const ThumbSwiper = ({ className }: Props) => {
    const { images, activeIndex, setActiveIndex, setThumbSwiper } =
        useImageGalleryContext();

    const isActive = (index: number) => index === activeIndex;

    return (
        <Swiper
            className={className}
            onSwiper={setThumbSwiper}
            spaceBetween={10}
            breakpoints={getEffectiveLayoutSettings(layoutSettings)}
            threshold={2}
            modules={[Thumbs]}
            watchSlidesProgress={true}
        >
            {images.map((image, index) => (
                <SwiperSlide
                    key={image.url}
                    tag={"button"}
                    className={cn("tw:p-2 tw:bg-transparent", {
                        "tw:border-0": !isActive(index),
                        "tw:border": isActive(index)
                    })}
                    onClick={() => {
                        setActiveIndex(() => index);
                    }}
                >
                    <img
                        className={cn(
                            "tw:h-full tw:w-full tw:object-center tw:object-contain"
                        )}
                        src={image.url}
                        alt={image.altText ?? ""}
                        loading={"lazy"}
                        decoding={"async"}
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};
